import React from 'react'

import { getAspectRatioPadding } from './utils/getAspectRatioPadding'

import { TIconProps } from './iconProps'

const IconExclamatoryMark: React.FC<TIconProps> = (props) => {
  return (
    <div style={props.style} className={`select-none ${props.className || 'w-24'}`} onClick={props.onClick}>
      <div className="relative h-0" style={getAspectRatioPadding(props.aspectRatio)}>
        <svg xmlns="http://www.w3.org/2000/svg" className="w-full h-full left-0 top-0 absolute" viewBox="0 0 48 48">
          <path
            fill="currentColor"
            d="M24 4c11.046 0 20 8.954 20 20s-8.954 20-20 20S4 35.046 4 24 12.954 4 24 4zm0 2C14.059 6 6 14.059 6 24s8.059 18 18 18 18-8.059 18-18S33.941 6 24 6zm0 26c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2zm0-20c1.586 0 2.872 1.286 2.872 2.872 0 .042 0 .084-.002.125l-.787 13.09c-.046 1.07-.927 1.913-1.998 1.913h-.17c-1.07 0-1.952-.843-1.998-1.913l-.787-13.09c-.069-1.585 1.16-2.925 2.745-2.994C23.917 12 23.958 12 24 12z"
          />
        </svg>
      </div>
    </div>
  )
}
export default IconExclamatoryMark
